import { EasyNewsWrapper } from "./EasyNews.style";
import { useState, useEffect } from "react";
import Aos from "aos";
import Footer from "../../components/global/Footer/Footer";
import ArticleGuides from "../../components/guides/ArticleGuides";
import { Button, Select } from "antd";
import { useMediaQuery } from "react-responsive";
import { NextSeo } from "next-seo";
import easynews_cover from "../../../public/easynews/easynews_cover.png";
import Image from "next/image";
import useSWR from "swr";
import fetcher from "../../fetchers/fetcher";
import HttpService from "../../services/HttpService";

export default function EasyNews({ articles, events }) {
  // const { data: articles } = useSWR(
  //   process.env.API_URL + "/articles",
  //   fetcher
  // );
  // const { data: events } = useSWR(
  //   process.env.API_URL + "/events",
  //   fetcher
  // );
  // const { data: articleTags } = useSWR(
  //   process.env.API_URL + "/article-tags",
  //   fetcher
  // );

  const [articleTags, setArticleTags] = useState([]);
  useEffect(() => {
    new HttpService().getData("article-tags").then((res) => {
      console.log(res);
      setArticleTags(res);
    });
  }, []);

  // if (!articles || !events || !articleTags) {
  //   return <>loading...</>;
  // }

  const [filter, setFilter] = useState(null);
  const [themeFilter, setThemeFilter] = useState(null);
  const { Option } = Select;

  const isDesktop = useMediaQuery({ minWidth: 1024 });

  useEffect(() => {
    Aos.init({ duration: 1500 });
  }, []);

  var filteredArticles = [];
  [...articles, ...events].forEach((article) => {
    if (themeFilter) {
      if (article.tags?.filter((tag) => tag.id == themeFilter).length) {
        filteredArticles.push(article);
      }
    } else {
      filteredArticles = [...articles, ...events];
    }
    if (filter == "Evenement") {
      filteredArticles = filteredArticles.filter(
        (article) => article.type == undefined
      );
    } else {
      filteredArticles = filteredArticles.filter((article) =>
        filter ? article.type == filter : true
      );
    }
  });

  return (
    <>
      <EasyNewsWrapper>
        <NextSeo
          title={"Easy news par Easy Capital"}
          description={
            "Retrouvez tous nos articles, conseils et guides sur la gestion de patrimoine sur cette page !"
          }
        />
        {isDesktop && (
          <div className="coverpic">
            <Image
              src={easynews_cover}
              alt="Couverture Easy News"
              priority
              placeholder="blur"
              height={300}
              objectFit="cover"
              objectPosition={"0px -180px"}
            />
          </div>
        )}
        <h1>Easy news par Easy Capital</h1>
        <p className="description">
          Retrouvez tous nos articles, conseils et guides sur la gestion de
          patrimoine sur cette page !
        </p>
        <div className="filters">
          {["Article", "Guide", "Evenement"].map((type, index) => {
            return (
              <Button
                key={index}
                onClick={() =>
                  type == filter ? setFilter(null) : setFilter(type)
                }
                className={filter == type ? "selected" : ""}
              >
                {type}s
              </Button>
            );
          })}
        </div>
        <Select
          value={themeFilter}
          onChange={(e) => setThemeFilter(e)}
          placeholder="Choisir un thème"
        >
          <Option value={null}>Tous</Option>
          {articleTags.map((articleTag, index) => {
            return (
              <Option key={index} value={articleTag.id}>
                {articleTag.title}
              </Option>
            );
          })}
        </Select>
        <div className="articlesWrapper">
          {filteredArticles.length ? (
            filteredArticles.map((article, index) => {
              return (
                <ArticleGuides
                  className="article"
                  content={
                    !article.type
                      ? article.formatted_description
                      : article.meta_description
                  }
                  title={article.title}
                  date={
                    !article.type
                      ? article.presentation_date
                      : article.created_at
                  }
                  img={
                    !article.type
                      ? article.photos?.[0].photo
                      : article.photo?.photo
                  }
                  type={"small"}
                  tags={!article.type ? [] : article.tags}
                  slug={article.slug}
                  key={index}
                  isEvent={article.type ? false : true}
                />
              );
            })
          ) : (
            <p className="noArticle">
              Aucun article ne correspond à vos critères de recherche
            </p>
          )}
        </div>
      </EasyNewsWrapper>
      <Footer />
    </>
  );
}
